// src/components/TextInspectionModal/HistoryTextInspectionModal.jsx
import React from 'react';
import { useTranslation } from 'react-i18next';
import ReactDOM from 'react-dom';
import { IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import HistoryTextInspectionPanel from './HistoryTextInspectionPanel';
import '../HeatmapModal/HeatmapModal.css'; // Reuse styles for the overlay/content box

const HistoryTextInspectionModal = ({ isOpen, onClose, regions, taskName, score }) => {
  const { t } = useTranslation();
  if (!isOpen) return null;

  const modalTitle = (score !== null && score !== undefined) 
    ? t('textInspection.modalTitle', { taskName, score })
    : t('textInspection.modalTitleNoScore', { taskName });

  const modalContent = (
    <div
      className="heatmap-modal-overlay open"
      onClick={onClose}
      role="dialog"
      aria-labelledby="text-inspection-modal-title"
    >
      <div className="heatmap-modal-content" onClick={(e) => e.stopPropagation()}>
        <header className="heatmap-modal-header">
          {/* <h2 id="text-inspection-modal-title">{taskName}: Flagged Quotes</h2> */}
          <h2 id="text-inspection-modal-title">{modalTitle}</h2>
          <IconButton
            aria-label={t('textInspection.closeAriaLabel')}
            onClick={onClose}
            className="heatmap-modal-close-button"
          >
            <CloseIcon />
          </IconButton>
        </header>
        <div className="heatmap-modal-body">
            <HistoryTextInspectionPanel regions={regions} />
        </div>
        <footer className="heatmap-modal-footer">
          <p className="history-mode-note">
            <strong>{t('heatmap.privacyNote').split(':')[0]}:</strong> {t('textInspection.footerNote').split(':')[1]}
          </p>
        </footer>
      </div>
    </div>
  );
  
  return ReactDOM.createPortal(modalContent, document.body);
};

export default HistoryTextInspectionModal;